export const hsaAccountOverviewHref = "https://www.ucbi.com/personal-banking/savings/health-savings-account/";
export const irs8889Href = "https://www.irs.gov/forms-pubs/about-form-8889";
export const irs502Href = "https://www.irs.gov/forms-pubs/about-publication-502";
export const irs1099Href = "https://www.irs.gov/pub/irs-pdf/i1099sa.pdf";
